import { SelectFieldOption } from "components/UI/SelectField";

export function interpreteLangOptionsGet(): SelectFieldOption[] {
  return [
    { value: "sr", label: "Srpski" },
    { value: "en", label: "English" },
  ];
}
